import { FindingDto } from './finding-dto';
import { ScanModule, ScanType, Severity } from '../enums';

export interface IdentecoFindingDto extends FindingDto {
  scanModule: ScanModule.Identeco;
  emailAddress: string;
  idHash: string;
  domain: string;
  isFixed: boolean;
  isNewLeak: boolean;
  numberOfLeaks: number;
  affiliation: string;
}

export namespace IdentecoFindingDto {
  export function mapFromApiValue(identecoFindingDto: any): IdentecoFindingDto {
    return {
      ...identecoFindingDto,
      scanType: ScanType.mapFromApiValue(identecoFindingDto.scanType),
      scanModule: ScanModule.Identeco,
      severity: Severity.mapFromApiValue(identecoFindingDto.severity),
    };
  }
}
